import React from 'react'

export default function Markaz() {
  return (
    <div>Markaz</div>
  )
}
